/* LPA Hide Audience picker and lock Flawless Darker ATC by customer. Marker: lpa-audience-hide-20260921-pro-commercial */
(function () {
  var DARKER_PRODUCT_ID = "7862547054811";
  var cartFixStarted = false;

  function textIsAudienceOnly(el) {
    var text = (el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    if (text.indexOf("audience") === -1) return false;
    return text.indexOf("consumer") !== -1 || text.indexOf("commercial") !== -1;
  }

  function isProfessional() {
    var body = document.body;
    if (!body) return false;
    if (body.classList.contains("customer-professional")) return true;
    return body.getAttribute("data-customer-professional") === "true";
  }

  function allowlist() {
    return window.lpaAudienceAllowlist || {};
  }

  function allowlistEntryForField(field) {
    var map = allowlist();
    var form = field.form || (field.closest && field.closest("form"));
    var pid = form && form.getAttribute("data-product-id");
    if (pid && map[String(pid)]) return map[String(pid)];
    var current = String(field.value || "");
    var id;
    for (id in map) {
      if (!Object.prototype.hasOwnProperty.call(map, id)) continue;
      var entry = map[id];
      if (String(entry.consumer) === current || String(entry.commercial) === current) return entry;
    }
    return null;
  }

  function hideAudienceUi() {
    document.querySelectorAll("[data-option-name]").forEach(function (el) {
      var name = (el.getAttribute("data-option-name") || "").toLowerCase();
      if (name === "audience") el.style.display = "none";
    });

    document.querySelectorAll(".selector-wrapper, .swatch, .productView-moreItem-product-variant .form-field").forEach(function (el) {
      if (textIsAudienceOnly(el)) el.style.display = "none";
    });

    document.querySelectorAll(".productView-moreItem-product-variant").forEach(function (el) {
      var labels = (el.textContent || "").toLowerCase();
      if (labels.indexOf("audience") !== -1 && labels.indexOf("consumer") !== -1) {
        var other = labels.replace("audience", "").replace("consumer", "").replace("commercial", "").replace(/[\s:/,-]+/g, "");
        if (other.length < 8) el.style.display = "none";
      }
    });

    document.querySelectorAll(".previewCartItem-variant, .cart-item-variant, .wpd-net-cart-item-variant-title").forEach(function (el) {
      var t = (el.textContent || "").trim();
      if (t === "Consumer" || t === "Commercial") {
        var wrap = el.closest(".previewCartItem-options, .cart-item-option") || el;
        wrap.style.display = "none";
      }
    });
  }

  function lockAudienceVariant() {
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      var entry = allowlistEntryForField(field);
      if (!entry) return;
      var next = isProfessional() ? entry.commercial : entry.consumer;
      if (next) field.value = String(next);
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error("lpa-audience-cart-http-" + res.status);
      return res.json();
    });
  }

  function rewriteLine(line, commercialId) {
    var qty = line.quantity || 1;
    var addBody = { id: Number(commercialId), quantity: qty };
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan_id) {
      addBody.selling_plan = line.selling_plan_allocation.selling_plan_id;
    }
    return postJson("/cart/change.js", { id: line.key, quantity: 0 }).then(function () {
      return postJson("/cart/add.js", addBody);
    });
  }

  function rewriteProDarkerCart() {
    if (!isProfessional() || cartFixStarted) return;
    var darker = allowlist()[DARKER_PRODUCT_ID];
    if (!darker) return;
    cartFixStarted = true;
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("lpa-audience-cart-js");
        return res.json();
      })
      .then(function (cart) {
        var lines = (cart.items || []).filter(function (item) {
          return String(item.product_id) === DARKER_PRODUCT_ID && String(item.variant_id) === String(darker.consumer);
        });
        if (!lines.length) return null;
        var chain = Promise.resolve();
        lines.forEach(function (line) {
          chain = chain.then(function () {
            return rewriteLine(line, darker.commercial);
          });
        });
        return chain.then(function () {
          return true;
        });
      })
      .then(function (changed) {
        if (changed && /\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        }
      })
      .catch(function () {
        cartFixStarted = false;
      });
  }

  function run() {
    hideAudienceUi();
    lockAudienceVariant();
    rewriteProDarkerCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  document.addEventListener("shopify:section:load", run);

  var observerTimer;
  if (typeof MutationObserver === "function" && document.documentElement) {
    var observer = new MutationObserver(function () {
      clearTimeout(observerTimer);
      observerTimer = setTimeout(function () {
        hideAudienceUi();
        lockAudienceVariant();
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
